var estateStoreGetters;
(function (estateStoreGetters) {
    estateStoreGetters["GET_METHOD"] = "GET_METHOD";
    estateStoreGetters["CURRENT_STEP"] = "CURRENT_STEP";
    estateStoreGetters["GET_CREATE_PAYLOAD"] = "GET_CREATE_PAYLOAD";
    estateStoreGetters["GET_ESTATE_LIST"] = "GET_ESTATE_LIST";
    estateStoreGetters["GET_UPDATE_MODE"] = "GET_UPDATE_MODE";
    estateStoreGetters["GET_SINGLE_ESTATE"] = "GET_SINGLE_ESTATE";
    estateStoreGetters["GET_CONFIGURE_ESTATE_PROPERTY_KITCHEN"] = "GET_CONFIGURE_ESTATE_PROPERTY_KITCHEN";
    estateStoreGetters["GET_CONFIGURE_ESTATE_PROPERTY_AREA"] = "GET_CONFIGURE_ESTATE_PROPERTY_AREA";
    estateStoreGetters["GET_CONFIGURE_ESTATE_PROPERTY_BALCONY"] = "GET_CONFIGURE_ESTATE_PROPERTY_BALCONY";
    estateStoreGetters["GET_CONFIGURE_ESTATE_PROPERTY_EQUIPMENT"] = "GET_CONFIGURE_ESTATE_PROPERTY_EQUIPMENT";
    estateStoreGetters["GET_CONFIGURE_ESTATE_PROPERTY_EXTENSION"] = "GET_CONFIGURE_ESTATE_PROPERTY_EXTENSION";
    estateStoreGetters["GET_CONFIGURE_ESTATE_PROPERTY_FLOOR"] = "GET_CONFIGURE_ESTATE_PROPERTY_FLOOR";
    estateStoreGetters["GET_CONFIGURE_ESTATE_PROPERTY_FURNISHING"] = "GET_CONFIGURE_ESTATE_PROPERTY_FURNISHING";
    estateStoreGetters["GET_CONFIGURE_ESTATE_PROPERTY_INCLUDE_RENT"] = "GET_CONFIGURE_ESTATE_PROPERTY_INCLUDE_RENT";
    estateStoreGetters["GET_CONFIGURE_ESTATE_PROPERTY_REQUISITES"] = "GET_CONFIGURE_ESTATE_PROPERTY_REQUISITES";
    estateStoreGetters["GET_CONFIGURE_ESTATE_PROPERTY_RESIDENCE"] = "GET_CONFIGURE_ESTATE_PROPERTY_RESIDENCE";
    estateStoreGetters["GET_SELECTED_RESIDENCE_TYPE"] = "SELECTED_RESIDENCE_TYPE";
    estateStoreGetters["GET_SELECTED_KITCHEN_TYPE"] = "GET_SELECTED_KITCHEN_TYPE";
    estateStoreGetters["GET_SELECTED_BALCONY_TYPE"] = "GET_SELECTED_BALCONY_TYPE";
    estateStoreGetters["GET_SELECTED_FLOOR_TYPE"] = "GET_SELECTED_FLOOR_TYPE";
    estateStoreGetters["GET_SELECTED_FURNISHING_TYPE"] = "GET_SELECTED_FURNISHING_TYPE";
    estateStoreGetters["GET_SELECTED_EXTENSION_TYPE"] = "GET_SELECTED_EXTENSION_TYPE";
    estateStoreGetters["COPY_ADDRESS"] = "COPY_ADDRESS";
    estateStoreGetters["GET_SELECTED_AREA"] = "GET_SELECTED_AREA";
    estateStoreGetters["GET_MAPPED_PROP"] = "GET_MAPPED_PROP";
    estateStoreGetters["GET_ESTATE_LAST_UPDATED"] = "GET_ESTATE_LAST_UPDATED";
})(estateStoreGetters || (estateStoreGetters = {}));
export default estateStoreGetters;
